import { Component, OnInit, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Title } from "@angular/platform-browser";
import { NgxSpinnerService } from "ngx-spinner";
import { PrintQueueService } from "../../Services/print-queue.service";

@Component({
  selector: "print-folder-revisions",
  templateUrl: "./print-folder-revisions.component.html",
  styleUrls: ["./print-folder-revisions.component.css"],
})
export class PrintFolderRevisionsComponent implements OnInit {
  public rowData = [];
  private gridApi;
  private gridOptions;
  private crudAction;
  public canUpdateForm: boolean;
  public clicked: boolean = false;
  public formData;
  public priceTypes = [];
  public priceGroups = [];
  public grades = [];
  public styles = [];
  public headerStyles = [];
  public newAction;
  public hasRebuildDate = false;

  constructor(
    private service: PrintQueueService,
    private toastr: ToastrService,
    private titleService: Title,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Print Folders");

    // Get grid data
    this.service.getB2BDocs().subscribe(
      (response) => {
        if (response.length > 0) {
          this.rowData = response;
          this.headerStyles = response;
        } else {
          this.rowData = null;
          this.toastr.warning("No records found", "Warning");
        }
      },
      (error) => {
        this.toastr.error("Unexpected error occurred", "Error");
      }
    );
  }
}
